// axios
import axios from 'axios'
import url from '@/url.js'
import router from '@/router.js'
import Vue from 'vue';

const baseURL = ''

const fetchData = axios.create({
  baseURL
})

fetchData.interceptors.response.use(
  response => response,
  error => {
    if (error.response !== null) {
      if (error.response.status === 401) {
        localStorage.clear()
        Vue.prototype.$vs.notify({
          position: "top-right",
          title: "Proses Dihentikan!",
          text: "Sesi login telah habis, silahkan login kembali",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
        router.replace('/pages/login').catch(() => { });
      } else if (error.response.status === 400) {
        console.log("Erorr : 400")
        Vue.prototype.$vs.notify({
          position: "top-right",
          title: "Oops!",
          text: error.response.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } else if (error.response.status === 404) {
        console.log("Erorr : 404")
        Vue.prototype.$vs.notify({
          position: "top-right",
          title: "Oops!",
          text: error.response.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } else {
        console.log("Erorr")
        Vue.prototype.$vs.notify({
          position: "top-right",
          title: "Sedang Terjadi Maintenance",
          text: "Tunggu Beberapa Saat Lagi",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    } else {
      console.log("Erorr")
      Vue.prototype.$vs.notify({
        position: "top-right",
        title: "Sedang Terjadi Maintenance",
        text: "Tunggu Beberapa Saat Lagi",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });
    }

    return error;
  });

export default fetchData;